$(window).resize(function() {
  var height = $('#main-header').height();
  $('body').css({
    'padding-top': height
  });
}).trigger('resize');

var boostRefreshCart;
(function() {
  var miniCartToggle = function(){ 
//     var hoverOrClick = function (e) {
//       e.preventDefault(); 
//       $('.cart-drawer_wrapper').toggleClass('cart-drawer--hidden');
//       $('.cart-drawer_overlay').toggleClass('active');
//       // do something common
//     }
//     $('.cart-icon-box-popup').click(hoverOrClick).hover(hoverOrClick);
    $( ".cart-icon-box-popup" )
    .mouseout(function() {
      $('.cart-drawer_wrapper').addClass('cart-drawer--hidden');
      $('.cart-drawer_overlay').removeClass('active');
    })
    .mouseover(function() {
      $('.cart-drawer_wrapper').removeClass('cart-drawer--hidden');
      $('.cart-drawer_overlay').addClass('active');
    })
//     $(document).on('click','.cart-drawer_toggle',function(e){
//       e.preventDefault(); 
//       //$('body').toggleClass('cart-drawer__opned');
//       $('.cart-drawer_wrapper').toggleClass('cart-drawer--hidden');
//       $('.cart-drawer_overlay').toggleClass('active');
//     });
    $(document).on('click','.cart-drawer__close, .cart-drawer_overlay, a[href="#addMoreItem"]',function(e){
      e.preventDefault();
      $('.cart-drawer_wrapper').addClass('cart-drawer--hidden');
      $('.cart-drawer_overlay').removeClass('active');
      //$('body').removeClass('cart-drawer__opned');
    }); 
  }
  function refrashCart(){
    $.ajax({ 
      type:"get",  
      dataType: "html",
      url: '/search',
      success: function(data){
        var cart_html = $(data).find('.cart-drawer_wrapper_box').html();
        $.getJSON('/cart.js', function(cart) { 
          var cart_count = cart.item_count;
          $('[data-cart-count]').html(cart.item_count);
          console.log(cart_count);
          if( cart_count > 0 ){
            $('.site-header__cart-count').removeClass('hide');
          }
          else{
            $('.site-header__cart-count').addClass('hide');
          }
        });
        $(document).find('.cart-drawer_wrapper_box').html(cart_html);
        // $('body').addClass('cart-drawer__opned');
        $('.cart-drawer_wrapper').removeClass('cart-drawer--hidden');
        $('.cart-drawer_overlay').addClass('active');
      }
    });

  } 
  var addToCart = function(){
    
    $(document).on('click', '.coll-variant-submit-btn', function( event ) {
      event.preventDefault();
      var variant_id = $(this).data('variant_id');
      var data = {
        id: variant_id,
        quantity: 1
      };
      $.ajax({
        type:"post",
        dataType: "json",
        url: '/cart/add.js',
        data:data,
        success: function(resp)
        {
          refrashCart();
        }
      }); 
    });
    
    $(document).on('click', '.product-form__cart-submit', function( event ) {
      event.preventDefault();
      var data = $(this).closest('.product-form').serialize();
      var button = $(this);
      button.find('[data-add-to-cart-text]').addClass('hide');
      button.find('[data-loader]').removeClass('hide');
      $.ajax({
        type:"post",
        dataType: "json",
        url: '/cart/add.js',
        data:data,
        success: function(resp)
        {
          button.find('[data-add-to-cart-text]').removeClass('hide');
          button.find('[data-loader]').addClass('hide');
          refrashCart();
          setTimeout(function(){ $('.cart-drawer_wrapper').addClass('cart-drawer--hidden'); }, 3000);
        }
      });
    });

    $('.custom__add-to-cart-home').submit(function( event ) {
      event.preventDefault();
      console.log('here');
      var data = $(this).serialize();
      var button = $(this).find('button[type="submit"]');
      button.find('[data-add-to-cart-text]').addClass('hide');
      button.find('[data-loader]').removeClass('hide');
      $.ajax({
        type:"post",
        dataType: "json",
        url: '/cart/add.js',
        data:data,
        success: function(resp){
          setTimeout(function(){
            button.find('[data-add-to-cart-text]').removeClass('hide');
            button.find('[data-loader]').addClass('hide');
          },1000)
          refrashCart();
        }
      }); 
    });

    $(document).on('click','.quick-view-content [type="submit"]',function(e){
      e.preventDefault();
      var form = $(this).closest('form'),
          data = $(form).serialize(),
          button = $(this);
      $.ajax({ 
        type:"post",
        dataType: "json",
        url: '/cart/add.js',
        data:data, 
        success: function(resp){
          //button.find('[data-add-to-cart-text]').removeClass('hide');
          //button.find('[data-loader]').addClass('hide');
          refrashCart();
          $('#quick-view-wrapper').hide();  
          $('body').removeClass('quick-view-open');
        }
      });
    });

    $('.product-card-form__cart-submit').click(function( event ) {
      event.preventDefault();
      var variant_id = $(this).parents('.product-card').find('input.size-item:checked').val();

      if(typeof variant_id == 'undefined') {
        variant_id = $(this).parents('.product-card').find('input.size-item:first').val();
      }
      var data = {
        id: variant_id,
        quantity: 1
      };
      var button = $(this).find('button[type="submit"]');
      button.find('[data-add-to-cart-text]').addClass('hide');
      button.find('[data-loader]').removeClass('hide');
      $.ajax({
        type:"post",
        dataType: "json",
        url: '/cart/add.js',
        data:data,
        success: function(resp){
          setTimeout(function(){
            button.find('[data-add-to-cart-text]').removeClass('hide');
            button.find('[data-loader]').addClass('hide');
          }, 1000)
          refrashCart();
        }
      }); 
    });
  }
  var removeCartItem = function(){
    $(document).on('click','.cart-drawer_remove',function(e){
      var id = $(this).data('id');
      e.preventDefault();
      $.ajax({
        type:"post",
        dataType: "json",
        url: '/cart/change.js',
        data:{quantity:0,id:id},
        success: function(data){
          console.log(data);
          refrashCart();
        }
      });
    });
  };
  var qtyUpdate = function() {
    $(document).on('click','.qtyUpdate',function(e) {
      e.preventDefault();
      var parent = $(this).parent();
      var $qtyButton = $(e.currentTarget);
      var curval = parseInt(parent.find('input[name="quantity"]').val());
      var varId = parent.find('input[name="quantity"]').attr('data-id');
      if( $qtyButton.hasClass('qtyplus')){
        curval = curval + 1;
        parent.find('input[name="quantity"]').val(curval);
      }
      else if($qtyButton.hasClass('qtyminus')) {
        if( curval > 1 ) {
          curval = curval - 1;
          parent.find(' input[name="quantity"]').val(curval);
        }
      }

      $.ajax({
        type:"post",
        dataType: "json",
        url: '/cart/change.js',
        data:{quantity:curval,id:varId},
        success: function(data){
          refrashCart();
        }
      });

    });
  };
  var FeaturedSlider = function() {
    $('.responsive-product-slider').slick({
      dots: true,
      infinite: true,
      speed: 300,
      slidesToShow: 4,
      slidesToScroll: 4,
      arrows:false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        }
      ]
    });
  };
  
  
   // var FeaturedColumns = function() {
   // $('.custom-icon-with-text-box .icon-with-text-block').slick({
   //   dots: true,
   //   infinite: true,
   //   speed: 300,
   //   slidesToShow: 3,
   //   slidesToScroll: 4,
   //   arrows:false,
   //   responsive: [
    //    {
   //       breakpoint: 480,
   //       settings: {
   //         slidesToShow: 1,
  //          slidesToScroll: 1
  //        }
  //      }
  //    ]
  //  });
 // };
  
  
  var productCardForm = function() {
    $('.boost-pfs-filter-product-item').hover(function(){
      $(this).addClass('hover');
      /* $(this).find('.boost-pfs-quickview-selector-wrapper').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }); */
    }, function(){
      // $(this).find('.boost-pfs-quickview-selector-wrapper').slick('unslick');
      $(this).removeClass('hover');
    }); 
    
  };
  var productCardProductSizeSelect = function() {
    $('.boost-pfs-swatch-element').click(function() {
      $('.boost-pfs-swatch-element').removeClass('active');
      $(this).addClass('active');
    });
  };
  var productVarticalThumbnailSlider = function() {
    $('.product-single__thumbnails-slider-track').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: true,
      vertical: true
    });

    if ($(window).width() <= 768) {
      if($('.product-single__thumbnails-slider-track').length > 0) {
        $('.product-single__thumbnails-slider-track').slick('unslick');
      }

      $('.product-single__thumbnails-slider-track, .product-single__thumbnails').hide();
      $('.product-single__media-wrapper').removeClass('hide');

      $('.et-product__gallery-mobile-slider').slick({
        dots: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false
      });
    }

    $(window).resize(function() {
      if ($(window).width() <= 768) {
        if($('.product-single__thumbnails-slider-track').length > 0) {
          $('.product-single__thumbnails-slider-track').slick('unslick');
        }

        $('.product-single__thumbnails-slider-track, .product-single__thumbnails').hide();
        $('.product-single__media-wrapper').removeClass('hide');

        $('.et-product__gallery-mobile-slider').slick({
          dots: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false
        });
      } else {
        //location.reload();
      }
    });
  };
  
  var collectionpagevariants = function() {
    $('.allswatches .swatch input[type=radio]').change(function() 
                                                       {
      var option_1="";
      var option_2="";
      var option_3="";
      var variant_obj;
      var variant_id;
      var selector_1 = $(this).parents('.allswatches').find('.swatch[data-option-index="0"]');
      var selector_2 = $(this).parents('.allswatches').find('.swatch[data-option-index="1"]');
      var selector_3 = $(this).parents('.allswatches').find('.swatch[data-option-index="2"]');
      var submit_selector = $(this).parents('.allswatches').siblings('.submitbuttonarea').find('.coll-variant-submit-btn');
      if(selector_1.length)
      {
        option_1 = selector_1.find("input[type='radio']:checked").val();
        if(option_1 == undefined || option_1 == "undefined")
        {
        option_1 = selector_1.find("input[type='radio']").val();
        }
      }
      if(selector_2.length)
      {
        option_2 = selector_2.find("input[type='radio']:checked").val();
        if(option_2 == undefined || option_2 == "undefined")
        {
        option_2 = selector_2.find("input[type='radio']").val();
        }
      }
      if(selector_3.length)
      {
        option_3 = selector_3.find("input[type='radio']:checked").val();
        if(option_3 == undefined || option_3 == "undefined")
        {
        option_3 = selector_2.find("input[type='radio']").val();
        }
      }
      if(option_1 != "" && option_2 != "" && option_3 != "")
      {
        variant_obj = $(this).parents('.allswatches').siblings('.allvariants').find('span[data-option-1="'+option_1+'"][data-option-2="'+option_2+'"][data-option-3="'+option_3+'"]');
      }
      else if(option_1 != "" && option_2 != "")
      {
        variant_obj = $(this).parents('.allswatches').siblings('.allvariants').find('span[data-option-1="'+option_1+'"][data-option-2="'+option_2+'"]');
      }
      else if(option_1 != "")
      {
        variant_obj = $(this).parents('.allswatches').siblings('.allvariants').find('span[data-option-1="'+option_1+'"]');
      }
      variant_id = variant_obj.data('variant_id');    
                                       
      if(variant_id == undefined || variant_id == "undefined")
      {
        submit_selector.text('Unavailable');
        submit_selector.prop('disabled', true);
      }
      else
      {
        if(variant_obj.data('available')) 
        {
          submit_selector.data('variant_id',variant_id);
          submit_selector.text('Add to bag');
          submit_selector.prop('disabled', false);
        }
        else
        {
          submit_selector.text('Sold Out');
          submit_selector.prop('disabled', true);
        }
      }
    });
   
    //$('.allswatches .col-slider-size').slick();
    

    
  };
  
  collectionpagevariants();
  miniCartToggle();
  addToCart();
  removeCartItem();
  qtyUpdate();
  FeaturedSlider();
  //FeaturedColumns();
  productCardForm();
  productCardProductSizeSelect();
  productVarticalThumbnailSlider();
  boostRefreshCart = refrashCart;
  $(document).on('shopify:section:load', function(event) { 
    collectionpagevariants();
    miniCartToggle();
    addToCart();
    removeCartItem();
    qtyUpdate();
    FeaturedSlider();
    //FeaturedColumns();
    productCardForm();
    productCardProductSizeSelect();
    productVarticalThumbnailSlider();
  });
}());

$(document).ready(function(e) {
 
   $('.product-details > ul > li > a.open-bio').click(function() {
  var current_status = $(this).parent().find(".bio-more").css('display');
  $('.product-details > ul > li > a.open-bio').removeClass('active');
  $('.product-details > ul  > li  > .bio-more').slideUp();
  if(current_status == 'none') {
    $(this).addClass('active');
    //$(this).next().addClass('active');
    $(this).parent().find(".bio-more").slideDown();
  }
});
  
   $('ul.bio-more-sustainability > li > a.open-bio1').click(function() {
  var current_status = $(this).parent().find(".bio-more1").css('display');
  $('ul.bio-more-sustainability > li > a.open-bio1').removeClass('active');
  $('ul.bio-more-sustainability  > li > .bio-more1').slideUp();
  if(current_status == 'none') {
    $(this).addClass('active');
    //$(this).next().addClass('active');
    $(this).parent().find(".bio-more1").slideDown();
  }
});
  

  var value = $('.swatch-element.color input[type="radio"]:checked').val();
  $('span#color_value').text(value);

  $(document).on('change', '.swatch-element.color input[type="radio"]', function() {
    var value = $(this).val();
    
    $('span#color_value').text(value);
  });
});


 if(jQuery( window ).width() < 768)
 {  
  jQuery('.site-footer__item-inner > p.h4').click(function() 
  {
    jQuery('.site-footer__item-inner > p.h4').removeClass('active');
    jQuery('.site-footer__item-inner > ul').removeClass('show');

    jQuery(this).closest('.site-footer__item-inner').find('p.h4').addClass('active');
    jQuery(this).closest('.site-footer__item-inner').find('ul').addClass('show');
  });
 }


// Menus accordion

$(document).ready(function()
{
  
  //Main menu accordion
  $('.accordion-content,.sub-accordion-content').css({'width' : '100%' });
  
  //Add Inactive Class To All Accordion Headers
  $('.accordion-header').toggleClass('inactive-header'); 
  //Sub menus 
  $('.sub-accordion-header').toggleClass('inactive-subheader'); 


  //Open The First Accordion Section When Page Loads nw
  // 	$('.accordion-header').first().toggleClass('active-header').toggleClass('inactive-header');
  // 	$('.accordion-content').first().slideDown().toggleClass('open-content');
	
	// The Accordion Effect
	$('.accordion-header').click(function () {
      $(this).find('.mobile-nav__icon').toggleClass('rotate');
		if($(this).is('.inactive-header')) {
			$('.active-header').toggleClass('active-header').toggleClass('inactive-header').next().slideToggle().toggleClass('open-content');
			$(this).toggleClass('active-header').toggleClass('inactive-header');
			$(this).next().slideToggle().toggleClass('open-content');
		}
		
		else {
			$(this).toggleClass('active-header').toggleClass('inactive-header');
			$(this).next().slideToggle().toggleClass('open-content');
		}
	});
//  Sub menus accordion 
	$('.sub-accordion-header').click(function () {
		if($(this).is('.inactive-subheader')) {
			$('.active-subheader').toggleClass('active-subheader').toggleClass('inactive-subheader').next().slideToggle().toggleClass('open-content');
			$(this).toggleClass('active-subheader').toggleClass('inactive-subheader');
			$(this).next().slideToggle().toggleClass('open-content');
		}
		
		else {
			$(this).toggleClass('active-subheader').toggleClass('inactive-subheader');
			$(this).next().slideToggle().toggleClass('open-content');
		}
	});
	return false;
});


//jQuery(window).resize(function (){
//  heightCal();
//});

//function heightCal(){
// var height = jQuery(window).height();
//  jQuery('.mobile-nav-wrapper').height(height);
//}
//heightCal();


$(document).ready(function(){
 

  $(document).on('click' ,'.block_shop_look .block_button a', function(){
    
    $(this).toggleClass('active');

    if($(this).parents('.block_shop_look').find('.sliders-block-section').hasClass('active')){
		$(this).parents('.block_shop_look').find('.sliders-block-section').removeClass('active');

    }

    else{
      $(this).parents('.block_shop_look').find('.sliders-block-section').addClass('active');
      $(this).parents('.block_shop_look').find('.sliders-block-section .block_products').slick({
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 4,
        responsive: [
          {
            breakpoint: 1000,
            settings: {
              arrows: false,
              centerMode: true,
              centerPadding: '40px',
              slidesToShow: 3,
              dots:true
            }
          },
          {
            breakpoint: 768,
            settings: {
              arrows: false,
              centerMode: true,
              centerPadding: '40px',
              slidesToShow: 2,
              dots:true
            }
          },
          {
            breakpoint: 480,
            settings: {
              arrows: false,
              centerMode: true,
              centerPadding: '40px',
              slidesToShow: 1,
              dots:true
            }
          }
        ]
      });
    }
  });
}); 


var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}


$( document ).ready(function() 
{
 setTimeout(() => { wcProductFeaturedImage(); }, 500);
});
  
function wcProductFeaturedImage()
{
  let fi = '';
  
  if(jQuery(window).width() > 767 )
  {
    fi = 'body.template-product .product-single .product-single__media-wrapper:first-of-type img.product-featured-media';
  }
  else
  {
    fi = 'body.template-product .product-single .product-single__media-wrapper.slick-slide.slick-current+.slick-slide img.product-featured-media';
  }

  if($(fi).length)
  {
    let s = $(fi).attr('sizes');
    if(typeof s === 'string' && s !== null && s !== 'undefined')
    {
      if(s.indexOf('px') != -1)
      {
        s = parseInt(s.replace('px',''));
        let ew = $(fi).width();
        if(typeof ew === 'number' && ew !== null && ew !== 'undefined')
        {
          ew = String(ew).split('.')[0];
          if(typeof ew === 'string' && ew !== null && ew !== 'undefined')
          {
            ew = Number(ew);
            if(typeof ew === 'number' && ew !== null && ew !== 'undefined')
            {
              if(s < ew )
              {   
                ew = ew + 'px';
                console.log('* Test-99 *',ew);
                $(fi).attr('sizes',ew);
              }
            }
          }
        }
      }
    }
  }
}


